<template>
  <div class="component package-cart-item">

    <!-- common for all activity -->
    <!-- <div class="date">Sat, 2 Feb, 2019 at 7:30am <span style="color: red;">({{ $t('general.label.same-day') }})</span></div> -->

    <div class="prices">
      <ol class="price-breakdown">
        <li v-for="(price, index) in priceBreakdown" :key="index">
          <strong>{{ price.qty }}</strong> {{ price.label }} × {{ $formatter.currency(price.price) }}
        </li>
      </ol>
      <div class="subtotal">{{ $formatter.currency(item.subTotal) }}</div>
    </div>
    <!-- common for all activity end -->

    <!-- if the item is Activity -->
    <div v-for="activity in packageActivities" class="package-item" :key="activity.id">
      <div class="item-name">{{ activity.name }}</div>

      <!-- P2P only -->
      <div v-if="activity.type === 'p2p'" class="p2p">
        <span class="from">{{ pickupLocation(activity) }}</span>
        <span class="to">{{ dropoffLocation(activity) }}</span>
      </div>
      <!-- P2P end -->

      <div class="date">{{ activityDate(activity) }}</div>

      <dl class="details">
        <!-- Rental only -->
        <div v-if="activity.type === 'rental'">
          <dt>{{ $t('general.label.pickup') }}:</dt>
          <dd>{{ rentalStart(activity) }}</dd>
          <dt>{{ $t('general.label.return') }}:</dt>
          <dd>{{ rentalEnd(activity) }}</dd>
        </div>
        <!-- Rental only end-->

        <div v-if="activity.pickupLocation > 0">
          <dt>{{ $t('general.label.pickup') }}:</dt>
          <dd>{{ pickupLocation(activity) }}<span v-if="activity.pickupAddress">, {{ activity.pickupAddress }}</span></dd>
        </div>
        <div v-if="activity.dropoffLocation > 0">
          <dt>{{ $t('general.label.dropoff') }}:</dt>
          <dd>{{ dropoffLocation(activity) }}<span v-if="activity.dropoffAddress">, {{ activity.dropoffAddress }}</span></dd>
        </div>

        <div v-for="(meal, mealIndex) in activity.meals" :key="mealIndex">
          <dt :key="`${mealIndex}-a`">{{ $t('form.label.meal') }}:</dt>
          <dd :key="`${mealIndex}-b`">{{ meal.name }}<span v-if="meal.notes">, {{ meal.notes }}</span></dd>
        </div>
      </dl>
    </div>

    <!-- if the item is Product -->
    <div v-for="product in packageProducts" class="package-item" :key="product.id">
      <div class="item-name">{{ product.name }} × {{ product.quantity }}</div>
    </div>

  </div>
</template>

<script>
// import Cart from '@/models/Cart';

export default {
  props: ['item'],

  data() {
    return {
      paxPrefix: `package${this.item.itemId}.`
    };
  },

  computed: {
    priceBreakdown() {
      return this.item.activityPriceBreakdown.map(bd => {
        let label = bd.label;

        if (bd.type === 'pax') {
          label = this.calculatePaxLabel(bd.label, bd.qty);
        }

        return {
          qty: bd.qty,
          label: label,
          price: bd.unitPrice
        };
      });
    },

    packageActivities() {
      return this.item.packageActivities;
    },

    packageProducts() {
      return this.item.packageProducts;
    }
  },

  methods: {
    activityDate(activity) {
      let startTime = this.$formatter.time(activity.startTime);
      let details = this.details(activity);

      if(details) {
        switch(details.activityType) {
          case 'regular':
            startTime = this.$formatter.time(details.listStartTime);
            break;
          case 'rental':
            startTime = this.$formatter.time(activity.rentalStartTime);
            break;
          case 'interval':
          default:
            startTime = this.$formatter.time(activity.startTime);
        }
      }

      return this.$formatter.date(activity.date) + " - " + startTime;
    },

    details(activity) {
      return this.item.details.activities.find(item => item.id === activity.itemId)
    },

    getLocation(activity, type) {
      let locations = this.details(activity)[`${type}s`];

      let locationName = null;
      let loc = activity[`${type}Location`];
      if (loc) {
        let obj = locations.find(item => item.id === loc);

        if (obj) {
          locationName = obj.name;

          let addr = this.item[`${type}Address`];
          if (addr) {
            locationName += `, ${addr}`;
          }
        }

      }
      return locationName;
    },

    pickupLocation(activity) {
      return this.getLocation(activity, 'pickup');
    },

    dropoffLocation(activity) {
      return this.getLocation(activity, 'dropoff');
    },

    rentalStart(activity) {
      return this.$formatter.date(activity.date) + " @ " + this.$formatter.time(activity.rentalStartTime);
    },

    rentalEnd(activity) {
      let item = this.details(activity);
      let endDate = item.rentalIsMultiDay ? this.$formatter.date(activity.rentalEndDate) : this.$formatter.date(activity.date);

      return endDate + " @ " + this.$formatter.time(activity.rentalEndTime);
    },

    calculatePaxLabel(pax, c = 2) {
      let key = `${this.paxPrefix}guest-picker.${pax}`;
      let label = this.$tc(key, c);

      if (key === label) {
        // we didn't find a label so fall back to no prefix
        label = this.$tc(`guest-picker.${pax}`, c);
      }

      return label;
    },
  }
}
</script>

<style lang="scss">
.component.package-cart-item {
  // For Package
  .package-item {
    margin-top: 10px;
    padding: 8px 10px;
    background-color: $colorBgGray;

    .item-name {
      @include font-h3;
    }
  }
}
</style>